export const GET_MEETING_ROOM_REQUEST = '[MEETING_ROOM] GET_MEETING_ROOM_REQUEST';
export const GET_MEETING_ROOM_SUCCESS = '[MEETING_ROOM] GET_MEETING_ROOM_SUCCESS';
export const GET_MEETING_ROOM_FAILED = '[MEETING_ROOM] GET_MEETING_ROOM_FAILED';

export const CREATE_MEETING_ROOM_REQUEST = '[MEETING_ROOM] CREATE_MEETING_ROOM_REQUEST';
export const CREATE_MEETING_ROOM_SUCCESS = '[MEETING_ROOM] CREATE_MEETING_ROOM_SUCCESS';
export const CREATE_MEETING_ROOM_FAILED = '[MEETING_ROOM] CREATE_MEETING_ROOM_FAILED';

export const EDIT_MEETING_ROOM_REQUEST = '[MEETING_ROOM] EDIT_MEETING_ROOM_REQUEST';
export const EDIT_MEETING_ROOM_SUCCESS = '[MEETING_ROOM] EDIT_MEETING_ROOM_SUCCESS';
export const EDIT_MEETING_ROOM_FAILED = '[MEETING_ROOM] EDIT_MEETING_ROOM_FAILED';

export const DELETE_MEETING_ROOM_REQUEST = '[MEETING_ROOM] DELETE_MEETING_ROOM_REQUEST';
export const DELETE_MEETING_ROOM_SUCCESS = '[MEETING_ROOM] DELETE_MEETING_ROOM_SUCCESS';
export const DELETE_MEETING_ROOM_FAILED = '[MEETING_ROOM] DELETE_MEETING_ROOM_FAILED';

export const RESET_MEETING_ROOMS_FORM = '[MEETING_ROOM] RESET_MEETING_ROOMS_FORM';

export const MEETING_ROOM_SEARCH_REQUEST = '[MEETING_ROOM] MEETING_ROOM_SEARCH_REQUEST';
export const MEETING_ROOM_SEARCH_SUCCESS = '[MEETING_ROOM] MEETING_ROOM_SEARCH_SUCCESS';
export const MEETING_ROOM_SEARCH_FAILED = '[MEETING_ROOM] MEETING_ROOM_SEARCH_FAILED';

export const GET_SCHEDULED_EVENTS_FOR_CALENDAR_REQUEST = '[MEETING_ROOM] GET_SCHEDULED_EVENTS_FOR_CALENDAR_REQUEST';
export const GET_SCHEDULED_EVENTS_FOR_CALENDAR_SUCCESS = '[MEETING_ROOM] GET_SCHEDULED_EVENTS_FOR_CALENDAR_SUCCESS';
export const GET_SCHEDULED_EVENTS_FOR_CALENDAR_FAILED = '[MEETING_ROOM] GET_SCHEDULED_EVENTS_FOR_CALENDAR_FAILED';

export const GET_MEETING_ROOM_PROVIDER_LIST_REQUEST = '[MEETING_ROOM] GET_MEETING_ROOM_PROVIDER_LIST_REQUEST';
export const GET_MEETING_ROOM_PROVIDER_LIST_SUCCESS = '[MEETING_ROOM] GET_MEETING_ROOM_PROVIDER_LIST_SUCCESS';
export const GET_MEETING_ROOM_PROVIDER_LIST_FAILED = '[MEETING_ROOM] GET_MEETING_ROOM_PROVIDER_LIST_FAILED';

export const SCHEDULE_EVENT_ENTRIES_SEARCH_REQUEST = '[MEETING_ROOM] SCHEDULE_EVENT_ENTRIES_SEARCH_REQUEST';
export const SCHEDULE_EVENT_ENTRIES_SEARCH_SUCCESS = '[MEETING_ROOM] SCHEDULE_EVENT_ENTRIES_SEARCH_SUCCESS';
export const SCHEDULE_EVENT_ENTRIES_SEARCH_FAILED = '[MEETING_ROOM] SCHEDULE_EVENT_ENTRIES_SEARCH_FAILED';
